import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'

export function CodeBlockNodeView() {
  return (
    <NodeViewWrapper className="bg-muted rounded-lg p-4 my-4 overflow-x-auto whitespace-pre font-mono">
      <NodeViewContent className="text-sm font-mono text-foreground" />
    </NodeViewWrapper>
  )
}
